import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import {
  createAttachedFile,
  getAttachedFiles,
  deleteAttachedFile,
} from "@api/attachedFiles";

import {
  createAttachedFileFailed,
  createAttachedFileSuccess,
  getAttachedFilesFailed,
  getAttachedFilesSuccess,
  deleteAttachedFileSuccess,
  deleteAttachedFileFailed,
  AttachedFilesInfoActions,
} from "@actions/HRM/employee/attachedFiles-actions";
import {
  CREATE_ATTACHED_FILE_INFO,
  GET_ATTACHED_FILES_INFO,
  DELETE_ATTACHED_FILE_INFO,
} from "@actions/HRM/employee/types";

import { isRequestCancelled } from "@helpers/routing";
import { StoreType } from "@reducers/types";
import { getGeneralInfoRequest } from "@actions/HRM/employee/general-info-actions";

export const attachedFilesMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: AttachedFilesInfoActions) => {
      const nextAction = next(action);

      switch (action.type) {
        case CREATE_ATTACHED_FILE_INFO.CREATE_ATTACHED_FILE_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await createAttachedFile(payload);

            dispatch(createAttachedFileSuccess(data));
            dispatch(getGeneralInfoRequest(payload.data.employeeID));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(createAttachedFileFailed());
            }
          }

          break;
        }

        case GET_ATTACHED_FILES_INFO.GET_ATTACHED_FILES_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await getAttachedFiles(payload);

            dispatch(getAttachedFilesSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getAttachedFilesFailed());
            }
          }

          break;
        }

        case DELETE_ATTACHED_FILE_INFO.DELETE_ATTACHED_FILE_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteAttachedFile(payload);

            dispatch(deleteAttachedFileSuccess(data));
            dispatch(getGeneralInfoRequest(payload.data.employeeID));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteAttachedFileFailed());
            }
          }

          break;
        }
      }
      return nextAction;
    };
  };
};
